import { ActionIconText, ArrowLink, Button, Col, Row } from "@/components";
import { EditPencil } from "@/icons";
import { CreditCard } from "@/icons/CreditCard";
import clsx from "clsx";
import "./ReservationRecapCard.scss";

type InfoSectionCardProps = {
  title?: string;
  firstStatusLabel?: string;
  secondStatusLabel?: string;
  code?: string;
  description?: any;
  onPressPay?: () => void;
  onPressPayLink?: string;
  onPressEdit?: () => void;
  onPressDownload?: () => void;
  downloadLabel?: string;
  payLabel?: string;
  editLabel?: string;
  asLink?: "a" | React.ComponentType<any>;
};

export const ReservationRecapCard = ({
  title,
  code,
  onPressDownload,
  firstStatusLabel,
  secondStatusLabel,
  description,
  onPressPay,
  onPressPayLink = undefined,
  onPressEdit,
  downloadLabel,
  payLabel,
  editLabel,
  asLink = "a",
}: InfoSectionCardProps) => {
  return (
    <Col className={clsx("shadow  br-x4 ui-radio-card-container-reservations")}>
      <Col p={"x24"} style={{ width: "100%" }}>
        <Col gap={"x8"}>
          <span className={"fs-7 fw-semibold text-slate-28"}>{code}</span>
          <span className={"text-slate-20 fw-semibold fs-4"}>{title}</span>
        </Col>
        <Row mt={"x16"} gap={"x16"}>
          <div className={"  px-x16 py-x4 bg-blue-15  rounded "}>
            <span className={"text-white fs-7 fw-bold"}>
              {firstStatusLabel}
            </span>
          </div>
          <div className={"  px-x16 py-x4 bg-status-warning  rounded "}>
            <span className={"text-white fs-7 fw-bold"}>
              {secondStatusLabel}
            </span>
          </div>
        </Row>
        <Col mt={"x24"}>{description}</Col>
        <Col mt={"x36"} mb={"x16"} className={"ui-reservation-recap-divider"} />
        <Row
          className={"actions-container-card-reservation"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Row alignItems={"center"} gap={"x16"} className={"action-link"}>
            {onPressPay ? (
              <ActionIconText
                textLabel={payLabel}
                icon={<CreditCard />}
                handleAction={onPressPay}
                handleIconAction={onPressPay}
                classNameText={"fw-bold"}
              />
            ) : onPressPayLink ? (
              <ArrowLink
                className="ui-reservation-recap-pay-link"
                asLink={asLink}
                href={onPressPayLink}
                arrowVisible={false}
              >
                <CreditCard />
                {payLabel}
              </ArrowLink>
            ) : (
              <></>
            )}

            {onPressEdit && (
              <div
                className={
                  (onPressPay || onPressPayLink) && "share-divider-reservations"
                }
              >
                <ActionIconText
                  textLabel={editLabel}
                  icon={<EditPencil />}
                  handleAction={onPressEdit}
                  handleIconAction={onPressEdit}
                  classNameText={"fw-bold"}
                />
              </div>
            )}
          </Row>
          <Button onClick={onPressDownload} variant="secondary" type="button">
            {downloadLabel}
          </Button>
        </Row>
      </Col>
    </Col>
  );
};
